<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar 
  click-not-close
   position-right
    parent="body" 
  default-index="1"
  color="primary"
  class="add-new-data-sidebar items-no-padding cstm-add-data-sidebar"
  :hidden-background="true"
  spacer
  v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4 class="heading-holder">Add New Notes</h4>
          <feather-icon icon="PlusIcon" @click="openAddForm" class="cursor-pointer"></feather-icon>
        <feather-icon icon="XIcon"  @click.stop="isSidebarActiveLocal = false"  class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <vs-row v-if="addform">
        <vs-col  vs-justify="center" vs-align="center" vs-w="12">
   
        <form data-vv-scope="Add_Notes" class="pl-5 prz-5">

          <vs-input placeholder="Notes Title" class="mt-5 pb-2 w-full" v-validate="'required'" data-vv-name="notes_title"
          name="notes_title"
          v-model="notes_title" />
          <div v-if="errors.has('Add_Notes.notes_title')" style="color:red;" class="invalid-feedback">{{ errors.first('Add_Notes.notes_title') }}</div>
        <vs-textarea 
        v-model="notes_content"
        name="notes_content"
        data-vv-name="notes_content"
        v-validate="'required|min:10'"
        label="Insert Notes"
        height="120px" />
        <div v-if="errors.has('Add_Notes.notes_content')" style="color:red;" class="invalid-feedback">{{ errors.first('Add_Notes.notes_content') }}</div>
      <vs-button  @click="closeAddNotes" style="float:right;" class="pb-3 mb-2 ml-3">Close</vs-button>

      <vs-button  @click="submitData" style="float:right;" class="pb-3 mb-2">Save</vs-button>

        </form>
        </vs-col>
    </vs-row>
<!-- {{sidebarNotesMeta}} -->

     <vs-row v-if="editform">
        <vs-col  vs-justify="center" vs-align="center" vs-w="12">
   
        <form data-vv-scope="Add_Notes" class="pl-5 prz-5">

          <vs-input placeholder="Notes Title" class="mt-5 pb-2 w-full" v-validate="'required'" data-vv-name="notes_title"
          name="notes_title"
          v-model="editdataform.title" />
          <div v-if="errors.has('Add_Notes.notes_title')" style="color:red;" class="invalid-feedback">{{ errors.first('Add_Notes.notes_title') }}</div>
        <vs-textarea 
        name="notes_content"
        data-vv-name="notes_content"
        v-validate="'required|min:10'"
        label="Insert Notes"
        height="120px"
        v-model="editdataform.note_content"
         />
        <div v-if="errors.has('Add_Notes.notes_content')" style="color:red;" class="invalid-feedback">{{ errors.first('Add_Notes.notes_content') }}</div>
      <vs-button  @click="closeEditNotes" style="float:right;" class="pb-3 mb-2 ml-3">Close</vs-button>

      <vs-button  @click="updateNotesData(editdataform.activities_note_id)" style="float:right;" class="pb-3 mb-2">Save</vs-button>

        </form>
        </vs-col>
    </vs-row>

    <component 
    :is="scrollbarTag"
    class="scroll-area--data-list-add-new"
    :settings="settings"
    :key="$vs.rtl"
          infinite-wrapper

    >


      <div class="p-6">

        <!-- Product Image -->  
              <!-- {{sidebarNotesMeta}}
              {{notesdata}} -->


      <!-- {{leadId}} -->

      <!-- <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button> -->
      
      <vs-row class="infinite-loader-container">
        <vs-card v-for="(notedata,index) in notesdata" :key="index">
            <vs-row>

            <vs-col vs-type="flex"  vs-justify="left" vs-align="center" vs-w="8"><h4>{{notedata.title}}</h4></vs-col>
            <vs-col  vs-type="flex" vs-justify="right" vs-align ="center" vs-w="2">
                 <vs-button radius color="primary" 
                    icon="edit"
                    class="ml-auto"    
                    @click="openEditForm(notedata.activities_note_id)"
                  ></vs-button> 
            </vs-col>
            <vs-col vs-type="flex" vs-justify="right"  vs-align="center" vs-w="2"> 
                    <vs-button radius
                    color="danger"
                    class="mx-auto"
                    icon="delete"
                    @click="DeleteNotes(notedata.activities_note_id)"
                     >
                    </vs-button> 
                  </vs-col>
            </vs-row>

            <vs-row>
            <vs-col vs-type="flex"  vs-justify="left" vs-align="center" vs-w="10">{{notedata.note_content}}</vs-col>
            <vs-col  vs-type="flex" vs-justify="right" vs-align ="center" vs-w="2"> </vs-col>
           </vs-row>
           <small style="float:right">{{notedata.created_at}}</small>
        </vs-card>
        <infinite-loading
         @infinite="infiniteHandler"
        :identifier="indetifyId"
                    :force-use-infinite-wrapper="true"

         spinner="circles"></infinite-loading>

     
    </vs-row>

                   
      </div>
         
    </component>
    

  </vs-sidebar>
</template>

<script>
import {InsertNotes, FetchLeadNotes, FetchSingleNotesId, UpdateActivityNotes, DeleteActivityNotes } from '@/api/activitynotes'

import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    leadId:{
      required : true
    }
  
    // data: {
    //   type: Object,
    //   default: () => {}
    // },
    // notesdata:{
    //   type: Array,
    //   default: () => []
    // },
    // sidebarNotesMeta:{
    //   type: Object,
    //   default: () => {}
    // }

  },
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      list: [],
      delete_id:'',

      addform:false,
      editform:false,
      indetifyId:+new Date(),

      //for edit form data
      editdataform:{
        activities_note_id:'',
        title:'',
        note_content:''
      },
      //for edit form data


      notes_content:'',
      notes_title:'',
      dataId: null,
      dataName: '',
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      //for pagination
      notesdata:[],
      page:1,

      // sidebarNotesData:[],
      sidebarNotesMeta:{
        'total': '',
        'limit': 10,
        'has_next': false,
        'current_page': 1,
        'next_page_url': null,
        'previous_page_url': ''
      }
    }
  },

  mounted ()  {
    this.fetchactivitynotesdata()
    
    
  },

  // watch: {
  //   isSidebarActive (val) {
  //     if (!val) return
  //     if (Object.entries(this.data).length === 0) {
  //       this.initValues()
  //       this.$validator.reset()
  //     } else {
        
  //       this.initValues()
  //     }
  //     // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
  //   }
  // },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar', false)
         
        }
      }
    },
    
   
    scrollbarTag () { return this.$store.getters.scrollbarTag }
    
  },
  methods: {
    initValues () {
      if (this.data.id) return
      this.notes_content = ''
    },
    openAddForm () {

      this.editform = false
      this.addform = true

    },
    closeAddNotes () {
      this.addform = false
    },
    closeEditNotes () {
      this.editform = false
    },
    openEditForm (id) {
      this.addform = false
      this.fetchSingleForm(id)
    },
    async fetchSingleForm (id) {

      try {
        const {data} = await FetchSingleNotesId(id)
        
        this.editdataform.activities_note_id =  data.data.activities_note_details.activities_note_id
        this.editdataform.title  = data.data.activities_note_details.title
        this.editdataform.note_content  = data.data.activities_note_details.note_content
        
        this.editform = true
      
      } catch (e) {
        
      }
    },
    updateNotesData () {
      // 
      this.$validator.validateAll('Add_Notes').then(result => {
        if (result) {
          this.updateData(this.editdataform)
        }
      })
    },
    async updateData (payload) {
      const data = await UpdateActivityNotes(payload)
      this.notesdata.forEach((element, index) => {
        if (element.activities_note_id === payload.activities_note_id) {
          this.notesdata[index].title = payload.title
          this.notesdata[index].activities_note_id = payload.activities_note_id
          this.notesdata[index].note_content = payload.note_content


        }
      })

      this.$emit('closeSidebar', 'Note Updated Successfully')


      this.editform = false
      
    },
    DeleteNotes (id) {
      this.deleteNotes(id)
    },
    async deleteNotes (id) {
      this.editform = false
      this.addform = false
      const data = await DeleteActivityNotes(id)
      const dlt_id  = this.notesdata.findIndex(item => item.activities_note_id === id)
      this.notesdata.splice(dlt_id, 1)
      
      
    },
    submitData () {
      this.$validator.validateAll('Add_Notes').then(result => {
        if (result) {
          const obj = {
            // noteId: 4,
            // title:'yasin',
            note_content:this.notes_content,
            title:this.notes_title,
            type: 'CRM',
            item_id : this.leadId,
            customer_id : this.$store.getters.customerId
          }
          // 
          this.addInsertNotes(obj)
          // this.initValues()
        }
      })
    },
    async addInsertNotes (payload) {
      try {
        const {data} = await InsertNotes(payload)
        
        const newData = {
          note_content :data.data.activities_note.note_content,
          title : data.data.activities_note.title,
          activities_note_id :data.data.activities_note.activities_note_id
        }
     
        
        
        // 
        // activities_note_id: 19
        // created_at: "2020-09-02T11:51:22.000000Z"
        // id: 19
        // item_id: "35"
        // module_id: 1
        // note_content: "New Notes New Notes"
        // title: "New Notes"
        // users_id: "1"


        this.$emit('closeSidebar', 'New Note Added Successfully')
      } catch (e) {
        
      }
    },
    async fetchactivitynotesdata () {
      
      const customerId = this.$store.getters.customerId

      const {data} = await FetchLeadNotes(this.page, this.leadId, customerId) 
      
      const dataActivityNotes = data.data.results
      this.notesdata = (dataActivityNotes)
      
      this.sidebarNotesMeta = data.data.meta

      
      // 
    },
    infiniteHandler ($state) {
      
      const customerId = this.$store.getters.customerId

     
      if (this.sidebarNotesMeta.has_next) {

        FetchLeadNotes(this.page  + 1, this.leadId, customerId).then(({data}) =>  {
          
          this.notesdata.push(...data.data.results)
          this.sidebarNotesMeta = data.data.meta
          
          
          this.page++
          //incremenet of page

          if (!this.sidebarNotesMeta.has_next) {
            $state.complete()

          } else {
            $state.loaded()
          }
        })
      } else {
        $state.complete()
        
      }


      // $state.complete()
      // this.fetchactivitynotesdata(this.sidebarNotesMeta, this.leadId)
  
    },
    editSingledata (id) {
      
    },
    openConfirm () {

      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Please Confirm',
        text: 'Are You Sure You want to deleted this Notes?',

        accept:this.acceptAlert
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}

body {
  margin: 0;
}

.example-list-item {
  margin: 0;
  padding: 0 10px;
  font-size: 14px;
  line-height: 40px;
  color: #666;
  background-color: #fafafa;
  border-top: 1px solid #fff;
  border-bottom: 1px solid #e3e3e3;
}

.example-list-item::before {
  content: 'Line: ';
}

.con-vs-dialog .vs-dialog {
  z-index: 3000000000000000000000;
}

</style>

<style>
.cstm-add-data-sidebar .vs-sidebar {
  right: 60px !important;
  margin-top: 107px !important;
  max-width: 400px !important;
}
.add-new-data-sidebar .vs-sidebar h4 {
  width: 80%;
}
</style>